/**
 * Created by ewald.stamp on 18.08.2014.
 */

angular
  .module('cfn')
  .controller('TermsAcceptanceController', TermsAcceptanceController);

TermsAcceptanceController.$inject = [
  '$scope',
  '$rootScope',
  '$location',
  '$dialog',
  'TermsAcceptanceService',
  'LoginService',
  'i18nFilter'
];
function TermsAcceptanceController(
  $scope,
  $rootScope,
  $location,
  $dialog,
  TermsAcceptanceService,
  LoginService,
  i18nFilter
) {
  'use strict';

  // Model Default values
  $scope.termAccepted = false;
  $scope.locale = app.credentials.locale;
  var person = app.credentials ? app.credentials.person : null;
  $scope.personName = person ? person.combinedName : '';
  $scope.permissionToBeContacted = false;

  // set up watchers
  $scope.$watch(
    function() {
      return app.credentials.locale;
    },
    function(newValue) {
      $scope.locale = newValue;
    }
  );

  // Submit form
  $scope.submitAccept = function() {
    // check if accepted
    if (!$scope.termAccepted) {
      return false;
    }

    // save with service
    app.showLoader();
    TermsAcceptanceService.accept($scope.permissionToBeContacted).then(
      function() {
        app.hideLoader();

        // redirect on success
        window.location = 'index.html#' + (app.pageSearch || '/dashboard');
      }
    );
  };

  $scope.decline = function() {
    var title = i18nFilter('fe.terms.acceptance.popup.title');
    var message = i18nFilter('fe.terms.acceptance.popup.text');
    var logout = i18nFilter('fe.terms.acceptance.popup.logout');
    var back = i18nFilter('fe.terms.acceptance.popup.back');

    $dialog
      .messageBox(title, message, [
        { result: 'logout', label: logout },
        { result: 'back', label: back, cssClass: 'btn-primary' }
      ])
      .open()
      .then(function(result) {
        if (result === 'logout') {
          $scope.logout();
        }
      });
  };

  $scope.logout = function() {
    LoginService.logoutAndCleanup();
  };
}
